var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import GroupsIcon from "@mui/icons-material/Groups";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import StadiumIcon from "@mui/icons-material/Stadium";
import { Card, CardContent, CircularProgress, Stack, Typography, } from "@mui/material";
import { useEffect, useRef } from "react";
import { FeedCard } from "./FeedCard";
export var Feed = function (_a) {
    var feed = _a.feed, hasNextPage = _a.hasNextPage, isFetchingNextPage = _a.isFetchingNextPage, fetchNextPage = _a.fetchNextPage;
    var loaderRef = useRef(null);
    useEffect(function () {
        if (!hasNextPage || isFetchingNextPage)
            return;
        var observer = new IntersectionObserver(function (_a) {
            var _b = __read(_a, 1), entry = _b[0];
            if (entry === null || entry === void 0 ? void 0 : entry.isIntersecting)
                fetchNextPage();
        });
        if (loaderRef.current)
            observer.observe(loaderRef.current);
        return function () { return observer.disconnect(); };
    }, [hasNextPage, isFetchingNextPage, fetchNextPage]);
    var allFeedItems = feed.pages.flatMap(function (page) { return page.results; });
    return (_jsxs(Stack, { spacing: 2, children: [allFeedItems.length === 0 ? (_jsx(Card, { sx: { p: 4, textAlign: "center" }, children: _jsxs(CardContent, { children: [_jsx(Typography, { variant: "h6", sx: { mb: 2, color: "text.secondary" }, children: "No Activity Yet" }), _jsx(Typography, { variant: "body1", color: "text.secondary", sx: { mb: 2 }, children: "There's no recent soccer activity to show." }), _jsx(Typography, { variant: "body2", color: "text.secondary", children: "Activity will appear here when matches are played, tournaments are organized, or transfers are completed." })] }) })) : (allFeedItems.map(function (item, idx) { return renderFeedCard(item, idx); })), isFetchingNextPage && _jsx(CircularProgress, {}), hasNextPage && _jsx("div", { ref: loaderRef })] }));
};
var FEED_CARD_CONFIG = {
    external_match: {
        icon: _jsx(GroupsIcon, {}),
        iconColor: "#6A1B9A",
        title: "External Match",
        getSubtext: function (data) {
            var _a;
            var m = data;
            var opponent = ((_a = m.opponentTeam) === null || _a === void 0 ? void 0 : _a.name) || "Opponent Team";
            return m.externalMatchResult
                ? "".concat(m.team.name, " ").concat(m.externalMatchResult.teamScore, " | ").concat(m.externalMatchResult.opponentTeamScore, " ").concat(opponent)
                : "".concat(m.team.name, " v ").concat(opponent);
        },
        getLink: function (data) {
            var m = data;
            return "/teams/".concat(m.team.id, "/external-matches/").concat(m.id);
        },
    },
    intra_squad_match: {
        icon: _jsx(SportsSoccerIcon, {}),
        iconColor: "#D32F2F",
        title: "Intra-Squad Match",
        getSubtext: function (data) {
            var m = data;
            return m.intraSquadMatchResult
                ? "".concat(m.teamAName, " ").concat(m.intraSquadMatchResult.teamAScore, " | ").concat(m.intraSquadMatchResult.teamBScore, " ").concat(m.teamBName)
                : "".concat(m.teamAName, " v ").concat(m.teamBName);
        },
        getLink: function (data) {
            var m = data;
            return "/teams/".concat(m.team, "/intra-squad-matches/").concat(m.id);
        },
    },
    intra_squad_tournament: {
        icon: _jsx(EmojiEventsIcon, {}),
        iconColor: "#1976D2",
        title: "Intra-Squad Tournament",
        getSubtext: function (data) {
            return data.tournamentName || "";
        },
        getLink: function (data) {
            var t = data;
            return "/teams/".concat(t.team, "/intra-squad-tournaments/").concat(t.id);
        },
    },
    transfer: {
        icon: _jsx(PersonAddIcon, {}),
        iconColor: "#388E3C",
        title: "Player Transfer",
        getSubtext: function (data) {
            var t = data;
            return "".concat(t.playerFirstName, " ").concat(t.playerLastName, " joined ").concat(t.teamName);
        },
        getLink: function (data) {
            return "/players/".concat(data.player);
        },
    },
    league_match: {
        icon: _jsx(StadiumIcon, {}),
        iconColor: "#E65100",
        title: "League Match",
        getSubtext: function (data) {
            var m = data;
            return m.leagueMatchResult
                ? "".concat(m.homeTeam.name, " ").concat(m.leagueMatchResult.homeTeamScore, " - ").concat(m.leagueMatchResult.awayTeamScore, " ").concat(m.awayTeam.name)
                : "".concat(m.homeTeam.name, " v ").concat(m.awayTeam.name);
        },
        getLink: function (data) {
            var m = data;
            return "/leagues/".concat(m.leagueId, "/seasons/").concat(m.seasonId, "/matches/").concat(m.id);
        },
    },
};
var renderFeedCard = function (item, key) {
    var config = FEED_CARD_CONFIG[item.activityType];
    if (!config)
        return null;
    return (_jsx(FeedCard, { icon: config.icon, iconColor: config.iconColor, title: config.title, subtext: config.getSubtext(item.data), timestamp: item.timestamp, to: config.getLink(item.data) }, key));
};
